import type { FeatureName } from '../store/featureDefinitions';
import flags from '../store/Store';
import { updateLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';

export default function setFeatureFlag(feature: FeatureName, isOn: boolean, sourceId?: string) {
    flags(sourceId).featureFlags.set(feature.toLowerCase(), isOn);
    updateLocalStorageOverrides([
        {
            name: feature.toLowerCase(),
            isEnabled: isOn,
        },
    ]);
}
